import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25.9 6.1A14 14 0 1030 16a13.94 13.94 0 00-4.1-9.9zm-1.41 18.39A12 12 0 1128 16a12 12 0 01-3.51 8.49z"/><path d="M18 22a2 2 0 01-4 0 2 2 0 012-2 2 2 0 012 2zM18 9.19L17.2 17a1.22 1.22 0 01-2.4 0L14 9.19a2 2 0 114 0z"/>';
export var ExclamationCircleOutlineSVG = function ExclamationCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ExclamationCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ExclamationCircleOutlineSVG);